import { InputV2 } from '@/components/Input';
import React, { FunctionComponent } from 'react';
import { Controller } from 'react-hook-form';

export const ControllerWithInput: FunctionComponent<{
  name: string;
  placeholder?: string;
  control: any;
  errors?: string;
  type?: 'text' | 'number';
  postfix?: string;
  maxLength?: number;
  disabled?: boolean;
  floatLabel?: boolean;
}> = ({ control, errors, name, placeholder, type, postfix, maxLength, disabled, floatLabel }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <InputV2
          id={name}
          placeholder={placeholder}
          onChange={(e) => onChange(e)}
          error={errors ? errors : ''}
          value={value || ''}
          type={type}
          postfix={postfix}
          maxLength={maxLength}
          disabled={disabled}
          floatLabel={floatLabel}
        />
      )}
    />
  );
};
